export default __webpack_public_path__ + "static/media/eye-brushes.01900fc1.jpg";